import { render, staticRenderFns } from "./snapshotAct.vue?vue&type=template&id=6d4f8e59&scoped=true&"
import script from "./snapshotAct.vue?vue&type=script&lang=ts&"
export * from "./snapshotAct.vue?vue&type=script&lang=ts&"
import style0 from "./snapshotAct.vue?vue&type=style&index=0&id=6d4f8e59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f8e59",
  null
  
)

export default component.exports